import React, { Fragment } from 'react';
import Link from 'gatsby-link';
import Img from "gatsby-image";
import Slider from "react-slick";
import Absorbed from '../static/images/absorbed_in.png';
import PersonalText from '../static/images/personal_text.png';
import FeatureImage from '../static/images/feature_image.png';
import TransferMoney from '../static/images/transfer_money.png';
import OnlineShopping from '../static/images/online_shopping.png';
import Airport from '../static/images/airport.png';
import Analyze from '../static/images/analyze.png';
import Directionality from '../static/images/web_detect directionality.png';
import EntryExit from '../static/images/web_track entry exit.png';
import TravelPatterns from '../static/images/web_identify travel patterns.png';
import AllDevices from '../static/images/web_cover all devices.png';
import Geofence from '../static/images/web_configure geo fence.png';
import DwellTimes from '../static/images/web_capture dwell times.png';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './landing.module.scss';
import { height } from 'window-size';

const settings = {
  dots: true,
  autoplay: true,
  infinite: true,
  speed: 400,
  slidesToShow: 1,
  slidesToScroll: 1
};

const LandingPage = () => (
  <Fragment>
    <div className={styles.landing__two__column__container}>
      <div className={styles.landing__two__column__container__box}>
        <Slider {...settings} className={styles.slick__slider}>
          <div>
            <div className={styles.landing__features__normal__subtitle}>49% of users said they’d use an app more if it sent them 
            <span className={styles.landing__features__highlighted__subtitle}> push notifications triggered by their location.</span>
            </div>
            <br/><br/>
            <div className={styles.landing__features__highlighted__title}>NearX</div>
            <div className={styles.landing__features__normal__title}>Be everywhere!</div>
            <div className={styles.btn__wrapper}>
              <Link to="/signup" className={styles['landing__btn']}>
                <span>Sign up for free</span>
              </Link>
            </div>
          </div>
          <div>
            <div className={styles.landing__features__normal__subtitle}>36% of 
            <span className={styles.landing__features__highlighted__subtitle}> people who shop using apps</span> said a mobile<span className={styles.landing__features__highlighted__subtitle}> location-based push notification</span>  influenced an in-store purchase they made.
            </div>
            <br/><br/>
            <div className={styles.landing__features__highlighted__title}>NearX</div>
            <div className={styles.landing__features__normal__title}>Be everywhere!</div>
            <div className={styles.btn__wrapper}>
              <Link to="/signup" className={styles['landing__btn']}>
                <span>Sign up for free</span>
              </Link>
            </div>
          </div>
          <div>
            <div className={styles.landing__features__normal__subtitle}>NearX enables delightful discoveries by blending the 
            <span className={styles.landing__features__highlighted__subtitle}> physical with the digital.</span>
            </div>
            <br/><br/>
            <div className={styles.landing__features__highlighted__title}>NearX</div>
            <div className={styles.landing__features__normal__title}>Be everywhere!</div>
            <div className={styles.btn__wrapper}>
              <Link to="/signup" className={styles['landing__btn']}>
                <span>Sign up for free</span>
              </Link>
            </div>
          </div>
        </Slider>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={Absorbed} className={styles.Absorbed}/>
      </div>
    </div>
    <div className={styles.landing__two__column__container_grey}>
      <div className={styles.landing__two__column__container__fullrow}>
        <span className={styles.landing__features__highlighted__title}>FEATURES</span>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={PersonalText} className={styles.Absorbed}/>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <div className={styles.landing__features__highlighted__text}>Productised</div>
        <div className={styles.landing__features__normal__text}>Location intelligence as a service (LIAASE™).</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Progressive</div>
        <div className={styles.landing__features__normal__text}>Learnings from multiple industries and clients ensures that you get advanced features and constant updates.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Contextual</div>
        <div className={styles.landing__features__normal__text}>Tailor your messages/prompts based on the whereabouts of your customers.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Scalable</div>
        <div className={styles.landing__features__normal__text}>Pay-as-you-go model for cost-effectiveness.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Legacy architecture compliant</div>
        <div className={styles.landing__features__normal__text}>No reliance on new or existing hardware.</div>
      </div>
    </div>
    <div className={styles.landing__three__column__container}>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__title__center}>WHY NearX?</div>
        <div className={styles.landing__features__normal__subtitle_center}>Under the hood features</div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Directionality} className={styles.Absorbed}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Detect directionality</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>In order to guide your users to the right location, NearX’s proprietary technology monitors the direction your users are moving in.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={EntryExit} className={styles.Absorbed}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Track entry/exit</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>NearX is able to identify movements as entries or exits, helping you determine the nature of nudges you can deliver to your users.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={DwellTimes} className={styles.Absorbed}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Capture dwell times</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>NearX intelligently marks users’ home and office locations depending on their dwell times in those areas. Identifying such locations helps reduce notification noise for users.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={TravelPatterns} className={styles.Absorbed}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Identify travel patterns</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Over time NearX identifies travel patterns of your users and enables you to deliver relevant nudges to forge repeat behavior.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={AllDevices} className={styles.Absorbed}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Cover all devices</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>Works across major operating systems – Android and iOS. Access to location services is the only permission required for NearX. The sdk is constantly optimized to minimize impact on battery life.</div>
        </div>
      </div>
      <div className={styles.landing__three__column__container__box_with_shadow}>
        <img src={Geofence} className={styles.Absorbed}/>
        <div style={{height:"100%"}}>
          <div className={styles.landing__features__highlighted__text_center}>Configure geofences easily</div>
          <br/>
          <div className={styles.landing__features__normal__text_center}>With an intuitive console, setting up geofences is quick and easy!</div>
        </div>
      </div>
    </div>
    <br/>
    <div className={styles.landing__two__column__container}>
      <div className={styles.landing__hero__container__heading}>
        Get started now!
      </div>
      <div className={styles.btn__wrapper}>
        <Link to="/signup" className={styles['landing__btn']}>
          <span>Sign up for free</span>
        </Link>
      </div>
    </div>
    <br/><br/>      
    <div className={styles.landing__two__column__container_grey}>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__title__center}>USE CASES</div>
        <div className={styles.landing__features__normal__title__center}>How can you use NearX?</div>
      </div>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__subtitle_center}>Banking and financial services</div>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={TransferMoney} className={styles.Absorbed}/>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <div className={styles.landing__features__highlighted__text}>Cross-sell</div>
        <div className={styles.landing__features__normal__text}>Offer financing products to retail banking customers and vice versa.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Boost redemptions</div>
        <div className={styles.landing__features__normal__text}>Users struggle to discover offers they may be eligible for at moments that matter. Send contextual reminders to customers about deals and offers they are eligible for.</div>
        <br/>
      </div>
      <br/>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__subtitle_center}>Retail</div>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <div className={styles.landing__features__highlighted__text}>Notify staff</div>
        <div className={styles.landing__features__normal__text}>Alert store staff about a customer’s presence in the vicinity of a store along with her consumption preferences.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Up/cross-sell with flash offers</div>
        <div className={styles.landing__features__normal__text}>To generate an unplanned walk-in, send your customers a flash offer when they are near your retail locations.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Contextual reminders</div>
        <div className={styles.landing__features__normal__text}>Send important prompts pertaining to loyalty points and feedback requests/redressals when customers are at or near your stores.</div>
        <br/>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={OnlineShopping} className={styles.Absorbed}/>
      </div>
      <br/>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__subtitle_center}>Travel and transport</div>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={Airport} className={styles.Absorbed}/>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <div className={styles.landing__features__highlighted__text}>Realtime updates</div>
        <div className={styles.landing__features__normal__text}>Send timely updates to commuters when they are approaching a travel hub.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Automatic check-in</div>
        <div className={styles.landing__features__normal__text}>Check your passengers in, assign them seats and guide them to their boarding gates when you detect them near a travel hub.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Upsell</div>
        <div className={styles.landing__features__normal__text}>Close a last minute sale by offering passengers deals on seats/f&b/entertainment/excess luggage/insurance.</div>
        <br/>
      </div>
      <br/>
      <div className={styles.landing__two__column__container__fullrow}>
        <div className={styles.landing__features__highlighted__subtitle_center}>Sports, events and entertainment</div>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <div className={styles.landing__features__highlighted__text}>Realtime updates</div>
        <div className={styles.landing__features__normal__text}>Share traffic, occupancy, line-up and other venue-related updates with patrons and fans.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Flash offers</div>
        <div className={styles.landing__features__normal__text}>Offer last minute deals on f&b/merchandise.</div>
        <br/>
        <div className={styles.landing__features__highlighted__text}>Navigation</div>
        <div className={styles.landing__features__normal__text}>Guide spectators to their seats by enabling indoor navigation on their phones once they are at the venue.</div>
        <br/>
      </div>
      <div className={styles.landing__two__column__container__box}>
        <img src={Analyze} className={styles.Absorbed}/>
      </div>
      <br/>
    </div>
    {/* <div className={styles.landing}>
      <div>
        <h1 className={styles.landing__header}>Location Intelligence Platform</h1>
        <div className={styles.landing__subheader}>NearX helps you build better products and make better decisions with location context.</div>
        <div className={styles.btn__wrapper}>
          <Link to="/signup" className={styles['landing__btn']}>
            <span>Sign up for free</span>
          </Link>
          <Link to="/sales" className={styles['landing__btn']}>
            <span>Contact Sales</span>
          </Link>
        </div>
      </div>
    </div> */}
    {/* <div className={styles.landing__hero__container}>
      <div className={styles.landing__hero__container__heading}>
        One solution for all teams..
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Engineering
        </div>
        <div className={styles.landing__hero__contents}>
          Engineering teams can integrate with NearX and build location features faster.
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Marketing
        </div>
        <div className={styles.landing__hero__contents}>
          Marketing teams can use NearX to grow engagement and retention with contextual messaging.
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Product
        </div>
        <div className={styles.landing__hero__contents}>
          Product teams can use NearX to delight users with personalized app experiences.
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Analytics
        </div>
        <div className={styles.landing__hero__contents}>
          Analytics teams can use NearX to get insights and understand user behaviour.
        </div>
      </div>
    </div>
    <div className={styles.landing__hero__container}>
      <div className={styles.landing__hero__container__heading}>
        One solution for all your customers..
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          SHOPPING & RETAIL
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Send contextual push notifications</li>
            <li>Build contextual in-app experiences</li>
            <li>Power order-ahead and delivery</li>
          </ul>
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          FOOD & DINING
        </div>        
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Send contextual push notifications</li>
            <li>Build contextual in-app experiences</li>
            <li>Power order-ahead and delivery</li>
          </ul>
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          TRAVEL & TRANSPORTATION
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Send contextual push notifications</li>
            <li>Build contextual in-app experiences</li>
            <li>Power automatic check-in</li>
          </ul>
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          ENTERTAINMENT & SPORTS
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Send contextual push notifications</li>
            <li>Build contextual in-app experiences</li>
            <li>Power automatic check-in</li>
          </ul>
        </div>
      </div>
    </div> */}
    {/* <div className={styles.landing__hero__container}>
      <div className={styles.landing__hero__container__heading}>
        Integrated with leading platforms..
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Customer Data 
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Segment</li>
          </ul>
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Marketing Automation
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Iterable</li>
          </ul>
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Analytics
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Amplitude</li>
            <li>Mixpanel</li>
          </ul>
        </div>
      </div>
      <div className={styles.landing__hero__box}>
        <div className={styles.landing__hero__header}>
          Geofencing
        </div>
        <div className={styles.landing__hero__contents}>
          <ul>
            <li>Localytics</li>
          </ul>
        </div>
      </div>
    </div> */}
    <br/><br/>
    <div className={styles.landing__two__column__container}>
      <div className={styles.landing__hero__container__heading}>
        Get started now!
      </div>
      <div className={styles.btn__wrapper}>
        <Link to="/signup" className={styles['landing__btn']}>
          <span>Sign up for free</span>
        </Link>
      </div>
    </div>      
  </Fragment>
);

export default LandingPage;



// WEBPACK FOOTER //
// ./src/pages/landing.js